import React,{useEffect} from 'react'

export default function Healths() {
  useEffect(() => {
    document.title = "Health Check";
  }, []);

  return (
    <pre style={{ margin: 0, padding: "1rem", fontSize: "1rem" }}>
      OK
    </pre>
  );
}
